<template>
  <div class="search-bar">
    <form class="input-area" @submit.prevent="search" method="post">
      <i class="iconfont ic_search_tab"></i>
      <input type="text" class="search" v-model=this.keyWord>
      <i ref="close" v-show="this.keyWord" class="iconfont guanbi" @click="close"></i>
    </form>
    <a ref="cancel" v-show="!this.keyWord" @click="goBack">取消</a>
    <a ref="search" v-show="this.keyWord" @click="search">搜索</a>
  </div>
</template>

<script>
import {useModalStore} from "@/store/pinia";

const HISTORY_LIMIT = 6
export default {
  name: "searchBar",
  props:["searchKey"],
  data(){
    return {
      keyWord:this.searchKey,
      modalStore:useModalStore(),
    }
  },
  watch:{
    keyWord(val){
      if (val){
        this.$refs.close.style.display = "block"
        this.$refs.search.style.display="block"
        this.$refs.cancel.style.display="none"
      }else {
        this.$refs.close.style.display = "none"
        this.$refs.search.style.display="none"
        this.$refs.cancel.style.display="block"
        this.$router.push({'name': 'search'});
      }
    }
  },
  methods:{
    search(){
      let searchHistory = this.modalStore.searchHistory
      const isDuplicate = searchHistory.some(
          (item) => item.KeyWord === this.keyWord
      );
      if (!isDuplicate) {
        searchHistory.unshift({ KeyWord: this.keyWord });
        if (searchHistory.length > HISTORY_LIMIT) {
          searchHistory = searchHistory.slice(0, HISTORY_LIMIT);
        }
        this.modalStore.setSearchHistory(searchHistory)
      }
      this.$router.push({'name': 'searchResult', params: {keyWord: this.keyWord}})
    },
    close(){
      this.keyWord='';
      this.$router.push({'name': 'search'});
    },
    goBack(){
      const path = sessionStorage.getItem('currentPath') || '/';
      this.$router.push(path);
    },
  },

}
</script>

<style scoped lang="scss">
.search-bar{
  height: 11.73333vmin;
  padding: 0 3.2vmin;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .input-area {
    height: 8vmin;
    width: 76vmin;
    line-height: 8vmin;
    padding: 0 3.2vmin;
    background: #f4f4f4;
    border-radius: 0.53333vmin;
    display: inline-block;
    .ic_search_tab {
      font-size: 5.33333vmin;
      color: #a0a0a0;
      vertical-align: middle;
    }
    input{
      color: #505050;
      border: none;
      background: transparent;
      width: 61.33333vmin;
    }
    input[type="text"]::-ms-clear,
    input[type="text"]::-webkit-search-cancel-button {
      display: none;
      width: 0;
      height: 0;
    }
  }
  a{
    font-size: 4vmin;
    color: #fb7299;
  }
  .guanbi{
    font-size: 3.73333vmin;
    color: #a0a0a0;
    float: right;
  }
}
</style>
